import { Link } from 'react-router-dom';
import FadeIn from '../components/FadeIn';

const IMAGES = {
  heroBg: "https://customer-assets.emergentagent.com/job_70c97ebb-d9b4-4dac-8385-96529bba2f67/artifacts/60gea409_1000001871.jpg",
  indoorSession: "https://customer-assets.emergentagent.com/job_70c97ebb-d9b4-4dac-8385-96529bba2f67/artifacts/bdoytqmu_website%20photo%204.jpg",
  gong: "https://customer-assets.emergentagent.com/job_70c97ebb-d9b4-4dac-8385-96529bba2f67/artifacts/alpxg7xy_website%20photo%203.jpg",
  lotus: "https://customer-assets.emergentagent.com/job_70c97ebb-d9b4-4dac-8385-96529bba2f67/artifacts/d1t7n4w6_website%20photo%20one.png",
};

const METHOD_STEPS = [
  { step: '01', title: 'Regulate', desc: 'Establishing safety and stability within the nervous system' },
  { step: '02', title: 'Reveal', desc: 'Gently bringing subconscious patterns into awareness' },
  { step: '03', title: 'Rewire', desc: 'Shifting conditioned responses and internal narratives' },
  { step: '04', title: 'Reintegrate', desc: 'Embodying a new baseline of clarity, safety, and self-trust' },
];

const SERVICES = [
  {
    title: 'Private Containers',
    desc: 'A high-touch, personalized space for deep and lasting transformation over time',
    tag: 'Long-Term Support',
    img: IMAGES.heroBg,
  },
  {
    title: 'Private Sessions',
    desc: 'Focused support for specific patterns, experiences, or areas of integration',
    tag: 'Individual Sessions',
    img: IMAGES.lotus,
  },
  {
    title: 'Sacred Ceremonies',
    desc: 'Intentional, guided experiences for release, reconnection, and energetic reset',
    tag: 'Group & Private',
    img: IMAGES.gong,
  },
];

const TESTIMONIALS = [
  {
    quote: "Resonant Healing helped me sort out my energy and feel lots better. I felt charged and peaceful very quickly. It was like being in the halo of a Deva. The healing made my life better. Thank you. Thank you. Thank you.",
    author: "Avery G.",
  },
  {
    quote: "Jennie is a gifted, compassionate, and powerful facilitator for grief circles. I have had the honor to witness her magic first hand and I highly recommend her.",
    author: "Elizabeth K.",
  },
  {
    quote: "I had such an amazing sound healing experience with Resonant Healing! They were so welcoming and knowledgeable and created a calming, healing atmosphere. The copper pyramid was incredible! I highly recommend them! Super talented with a great variety of instruments from crystal bowls, chimes, tuning forks, didgeridoo and much more! I'm looking forward to another session soon! It was awesome!",
    author: "Nicole O.",
  },
  {
    quote: "Absolutely recommend! 10 out of 10. These wonderful humans agreed to bless our wedding ceremony with the sounds of healing, love, and growth after a passing interaction! Their presence sent the ceremony over the top! Thank you so much for what you do. I could feel my soul singing the entire time! An unforgettable moment that will live in my minds eye forever.",
    author: "Fawn S.",
  },
  {
    quote: "Great people, great noises. I had the pleasure of receiving a sound bath healing from Resonant Healing and it was absolutely amazing. Totally recommend.",
    author: "Andrew S.",
  },
  {
    quote: "I have done 3 healing baths with Resonant Healing and each time I end up feeling so relaxed afterwards. The 1st time I had gone over 2 days without sleep and after the sound bath I felt like I had slept through a night. Some of the purest souls I have met!",
    author: "Bill M.",
  },
  {
    quote: "Resonant Healing did an exceptional and outstanding healing for my dad, with actual results! I highly recommend you hire her. If you or anyone wants a fantabulous healing you will get high quality results. It gave my heart so much joy and I'm so happy. Thank you more than words can say, Jennie!",
    author: "Avery G.",
  },
];

const TRANSFORMATION = [
  'A deeper sense of safety and regulation within your body.',
  'More clarity in your thoughts, decisions, and direction.',
  'A softening of long-held patterns and protective responses.',
  'A more grounded, connected relationship with yourself.',
  'An increased capacity to move through life with presence and intention.',
];

const FOR_YOU = [
  "You feel caught in patterns that no longer serve you, but haven't fully shifted.",
  "You've done inner work, yet something deeper is still asking to be seen and supported.",
  "You're ready to feel safe in your body—not just understand your patterns intellectually.",
  "You desire a more grounded, aligned way of living and relating to yourself.",
];

const HomePage = () => {
  return (
    <div data-testid="home-page">

      {/* ── HERO ─────────────────────────────────────────────────────── */}
      <section
        id="hero"
        data-testid="hero-section"
        className="relative min-h-screen flex items-center justify-center overflow-hidden"
      >
        <div className="absolute inset-0 z-0">
          <img
            src={IMAGES.heroBg}
            alt="Sound healing with crystal bowls"
            className="w-full h-full object-cover"
          />
          <div
            className="absolute inset-0"
            style={{ background: 'linear-gradient(160deg, rgba(247,244,239,0.88) 0%, rgba(247,244,239,0.78) 50%, rgba(234,227,217,0.85) 100%)' }}
          />
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center hero-animate" style={{ paddingTop: '130px', paddingBottom: '90px' }}>
          <p
            className="font-serif text-3xl sm:text-4xl font-light mb-6"
            style={{ color: '#7E8C74', letterSpacing: '0.04em' }}
          >
            Resonant Healing
          </p>
          <h1
            className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-tight mb-8"
            style={{ color: '#2B2B2B', letterSpacing: '-0.02em' }}
          >
            Regulate Your Nervous System.<br />
            Return to Your Truth.<br />
            Elevate Your Life.
          </h1>
          <p
            className="text-base sm:text-lg leading-relaxed max-w-2xl mx-auto mb-12"
            style={{ color: 'rgba(43,43,43,0.68)', fontFamily: 'Inter, sans-serif' }}
          >
            A trauma-informed approach to deep healing through subconscious work, energetic alignment, and nervous system regulation.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="https://forms.gle/acnQmapg39FqW7wL7"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-apply-btn"
              className="rounded-full text-sm font-medium transition-all duration-300 hover:opacity-88 hover:shadow-lg"
              style={{ background: '#A8B5A2', color: '#2B2B2B', padding: '16px 38px', fontFamily: 'Inter, sans-serif' }}
            >
              Apply to Work Together
            </a>
            <a
              href="#services"
              data-testid="hero-explore-btn"
              className="rounded-full text-sm font-medium transition-all duration-300"
              style={{ border: '1.5px solid #C6A96B', color: '#C6A96B', padding: '15px 38px', fontFamily: 'Inter, sans-serif' }}
              onMouseEnter={(e) => { e.currentTarget.style.background = '#C6A96B'; e.currentTarget.style.color = '#2B2B2B'; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#C6A96B'; }}
            >
              Explore Services
            </a>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
          <span className="text-xs tracking-widest uppercase" style={{ color: '#A8B5A2', fontFamily: 'Inter, sans-serif' }}>Scroll</span>
          <div style={{ width: '1px', height: '48px', background: 'linear-gradient(to bottom, #A8B5A2, transparent)' }} />
        </div>
      </section>

      {/* ── THIS IS FOR YOU ──────────────────────────────────────────── */}
      <section id="for-you" data-testid="for-you-section" className="py-24 md:py-32" style={{ background: '#EAE3D9' }}>
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <FadeIn>
            <p className="text-xs tracking-[0.3em] uppercase font-medium mb-4" style={{ color: '#7E8C74' }}>
              You Are Welcome Here
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl mb-16" style={{ color: '#2B2B2B' }}>
              This Work Is For You If…
            </h2>
          </FadeIn>
          <div className="grid md:grid-cols-2 gap-10">
            {FOR_YOU.map((item, i) => (
              <FadeIn key={i} delay={i * 120}>
                <div className="flex gap-5 items-start">
                  <div className="mt-3 flex-shrink-0" style={{ width: '28px', height: '1px', background: '#C6A96B' }} />
                  <p className="text-base leading-relaxed" style={{ color: 'rgba(43,43,43,0.8)', fontFamily: 'Inter, sans-serif' }}>
                    {item}
                  </p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHAT I DO ────────────────────────────────────────────────── */}
      <section id="what-i-do" data-testid="what-i-do-section" className="py-24 md:py-32" style={{ background: '#F7F4EF' }}>
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <FadeIn>
              <p className="text-xs tracking-[0.3em] uppercase font-medium mb-4" style={{ color: '#7E8C74' }}>
                The Approach
              </p>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl mb-8" style={{ color: '#2B2B2B' }}>
                A More Integrated Approach to Healing
              </h2>
              <div className="space-y-5">
                {[
                  'I guide individuals through deep, trauma-informed healing by working with the nervous system, subconscious patterns, and energetic field.',
                  'This work is not about fixing you.',
                  'It is about creating the conditions your system needs to soften, unwind, and reorganize in a way that feels safe and sustainable.',
                  'Rather than forcing change, we allow transformation to occur through attunement, awareness, and intentional support.',
                ].map((para, i) => (
                  <p
                    key={i}
                    className="text-base leading-relaxed"
                    style={{ color: 'rgba(43,43,43,0.76)', fontFamily: 'Inter, sans-serif', fontStyle: i === 1 ? 'italic' : 'normal', fontWeight: i === 1 ? '500' : '400' }}
                  >
                    {para}
                  </p>
                ))}
              </div>
            </FadeIn>
            <FadeIn delay={200}>
              <div className="overflow-hidden rounded-3xl" style={{ boxShadow: '0 24px 64px rgba(126,140,116,0.14)' }}>
                <img
                  src={IMAGES.indoorSession}
                  alt="Indoor healing session with crystal bowls"
                  className="w-full object-cover img-hover"
                  style={{ height: '500px' }}
                />
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* ── METHOD ───────────────────────────────────────────────────── */}
      <section id="method" data-testid="method-section" className="py-24 md:py-32" style={{ background: '#EAE3D9' }}>
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <FadeIn>
            <div className="text-center mb-20">
              <p className="text-xs tracking-[0.3em] uppercase font-medium mb-4" style={{ color: '#7E8C74' }}>The Process</p>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl" style={{ color: '#2B2B2B' }}>
                The Resonant Regulation Method™
              </h2>
              <p className="text-base mt-5 max-w-xl mx-auto" style={{ color: 'rgba(43,43,43,0.65)', fontFamily: 'Inter, sans-serif' }}>
                This work follows a grounded, intentional process:
              </p>
            </div>
          </FadeIn>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {METHOD_STEPS.map((item, i) => (
              <FadeIn key={i} delay={i * 140}>
                <div
                  className="p-8 rounded-3xl h-full"
                  style={{ background: '#F7F4EF', boxShadow: '0 8px 40px rgba(126,140,116,0.07)' }}
                >
                  <p className="font-serif text-4xl font-light mb-5" style={{ color: '#C6A96B' }}>{item.step}</p>
                  <h3 className="font-serif text-xl mb-3" style={{ color: '#2B2B2B' }}>{item.title}</h3>
                  <p className="text-sm leading-relaxed" style={{ color: 'rgba(43,43,43,0.68)', fontFamily: 'Inter, sans-serif' }}>
                    {item.desc}
                  </p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* ── SERVICES PREVIEW ─────────────────────────────────────────── */}
      <section id="services" data-testid="services-preview-section" className="py-24 md:py-32" style={{ background: '#F7F4EF' }}>
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <FadeIn>
            <div className="text-center mb-16">
              <p className="text-xs tracking-[0.3em] uppercase font-medium mb-4" style={{ color: '#7E8C74' }}>How We Work</p>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl" style={{ color: '#2B2B2B' }}>
                Ways to Work Together
              </h2>
            </div>
          </FadeIn>
          <div className="grid md:grid-cols-3 gap-8 mb-14">
            {SERVICES.map((service, i) => (
              <FadeIn key={i} delay={i * 130}>
                <div
                  className="rounded-3xl overflow-hidden group cursor-pointer"
                  style={{ background: '#EAE3D9', boxShadow: '0 8px 40px rgba(126,140,116,0.08)', transition: 'box-shadow 0.4s ease' }}
                  onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 16px 56px rgba(126,140,116,0.16)'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 8px 40px rgba(126,140,116,0.08)'; }}
                >
                  <div className="overflow-hidden" style={{ height: '220px' }}>
                    <img
                      src={service.img}
                      alt={service.title}
                      className="w-full h-full object-cover img-hover"
                    />
                  </div>
                  <div className="p-8">
                    <span className="text-xs tracking-[0.2em] uppercase font-medium" style={{ color: '#7E8C74', fontFamily: 'Inter, sans-serif' }}>
                      {service.tag}
                    </span>
                    <h3 className="font-serif text-2xl mt-2 mb-3" style={{ color: '#2B2B2B' }}>{service.title}</h3>
                    <p className="text-sm leading-relaxed" style={{ color: 'rgba(43,43,43,0.7)', fontFamily: 'Inter, sans-serif' }}>
                      {service.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
          <div className="text-center">
            <Link
              to="/services"
              data-testid="view-all-services-btn"
              className="inline-block rounded-full text-sm font-medium transition-all duration-300 hover:opacity-85"
              style={{ background: '#C6A96B', color: '#2B2B2B', padding: '16px 42px', fontFamily: 'Inter, sans-serif' }}
            >
              View All Services
            </Link>
          </div>
        </div>
      </section>

      {/* ── TRANSFORMATION ───────────────────────────────────────────── */}
      <section id="transformation" data-testid="transformation-section" className="py-24 md:py-32" style={{ background: '#EAE3D9' }}>
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <FadeIn>
            <div className="text-center mb-16">
              <p className="text-xs tracking-[0.3em] uppercase font-medium mb-4" style={{ color: '#7E8C74' }}>The Shift</p>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl" style={{ color: '#2B2B2B' }}>
                What Becomes Possible
              </h2>
            </div>
          </FadeIn>
          <div className="space-y-5">
            {TRANSFORMATION.map((item, i) => (
              <FadeIn key={i} delay={i * 100}>
                <div
                  className="flex items-start gap-5 py-5 px-7 rounded-2xl"
                  style={{ background: '#F7F4EF', boxShadow: '0 4px 20px rgba(126,140,116,0.06)' }}
                >
                  <div className="flex-shrink-0 mt-2" style={{ width: '2px', height: '18px', background: '#C6A96B', borderRadius: '2px' }} />
                  <p className="text-base leading-relaxed" style={{ color: 'rgba(43,43,43,0.8)', fontFamily: 'Inter, sans-serif' }}>
                    {item}
                  </p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* ── TESTIMONIALS ─────────────────────────────────────────────── */}
      <section id="testimonials" data-testid="testimonials-section" className="py-24 md:py-32" style={{ background: '#F7F4EF' }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <FadeIn>
            <div className="text-center mb-16">
              <p className="text-xs tracking-[0.3em] uppercase font-medium mb-4" style={{ color: '#7E8C74' }}>
                In Their Words
              </p>
              <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl" style={{ color: '#2B2B2B' }}>
                Words from Those Who've Experienced This Work
              </h2>
            </div>
          </FadeIn>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {TESTIMONIALS.map((t, i) => (
              <FadeIn key={i} delay={i * 100}>
                <div
                  className="p-8 rounded-3xl flex flex-col h-full"
                  style={{ background: '#EAE3D9', boxShadow: '0 8px 40px rgba(126,140,116,0.07)' }}
                >
                  <p
                    className="font-serif text-3xl leading-none mb-5"
                    style={{ color: '#C6A96B' }}
                  >
                    &ldquo;
                  </p>
                  <p
                    className="font-serif text-base leading-relaxed flex-1 mb-6"
                    style={{ color: 'rgba(43,43,43,0.82)', fontStyle: 'italic' }}
                  >
                    {t.quote}
                  </p>
                  <div className="flex items-center gap-3">
                    <div style={{ width: '20px', height: '1px', background: '#C6A96B' }} />
                    <p
                      className="text-xs tracking-[0.15em] uppercase font-medium"
                      style={{ color: '#7E8C74', fontFamily: 'Inter, sans-serif' }}
                    >
                      {t.author}
                    </p>
                  </div>
                </div>
              </FadeIn>
            ))}
          </div>
          <FadeIn delay={200}>
            <div className="text-center mt-14">
              <p className="text-sm mb-5" style={{ color: 'rgba(43,43,43,0.5)', fontFamily: 'Inter, sans-serif', fontStyle: 'italic' }}>
                Loved your experience? We'd be honoured to hear from you.
              </p>
              <a
                href="https://forms.gle/GfPTMGH3VFdpWdr79"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="write-testimony-btn"
                className="inline-flex items-center gap-2 rounded-full text-sm font-medium transition-all duration-300 hover:opacity-85"
                style={{ border: '1.5px solid #C6A96B', color: '#C6A96B', padding: '13px 32px', fontFamily: 'Inter, sans-serif' }}
                onMouseEnter={e => { e.currentTarget.style.background = '#C6A96B'; e.currentTarget.style.color = '#2B2B2B'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#C6A96B'; }}
              >
                Write a Testimony
              </a>
            </div>
          </FadeIn>
        </div>
      </section>

      {/* ── ABOUT PREVIEW ────────────────────────────────────────────── */}
      <section id="about-preview" data-testid="about-preview-section" className="py-24 md:py-32" style={{ background: '#F7F4EF' }}>
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <FadeIn>
              <div className="overflow-hidden rounded-3xl" style={{ boxShadow: '0 24px 64px rgba(126,140,116,0.14)' }}>
                <img
                  src={IMAGES.gong}
                  alt="Practitioner conducting sound healing ceremony"
                  className="w-full object-cover img-hover"
                  style={{ height: '500px' }}
                />
              </div>
            </FadeIn>
            <FadeIn delay={200}>
              <p className="text-xs tracking-[0.3em] uppercase font-medium mb-4" style={{ color: '#7E8C74' }}>
                About This Work
              </p>
              <h2 className="font-serif text-3xl sm:text-4xl mb-8" style={{ color: '#2B2B2B' }}>
                A Space Rooted in Safety, Presence, and Integrity
              </h2>
              <div className="space-y-5 mb-10">
                {[
                  'This work is grounded in trauma-informed care, deep attunement, and respect for your individual process.',
                  'You are not rushed, pushed, or expected to be anywhere other than where you are.',
                  'You are met there—with presence, care, and intention.',
                ].map((para, i) => (
                  <p key={i} className="text-base leading-relaxed" style={{ color: 'rgba(43,43,43,0.76)', fontFamily: 'Inter, sans-serif' }}>
                    {para}
                  </p>
                ))}
              </div>
              <Link
                to="/about"
                data-testid="learn-more-btn"
                className="inline-block rounded-full text-sm font-medium transition-all duration-300 hover:opacity-85"
                style={{ background: '#A8B5A2', color: '#2B2B2B', padding: '14px 36px', fontFamily: 'Inter, sans-serif' }}
              >
                Learn More
              </Link>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* ── CONTACT ──────────────────────────────────────────────────── */}
      <section id="contact" data-testid="contact-section" className="py-24 md:py-32" style={{ background: '#EAE3D9' }}>
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-2 gap-16 items-center">
            <FadeIn>
              <p className="text-xs tracking-[0.3em] uppercase font-medium mb-4" style={{ color: '#7E8C74', fontFamily: 'Inter, sans-serif' }}>
                Get in Touch
              </p>
              <h2 className="font-serif text-3xl sm:text-4xl mb-6" style={{ color: '#2B2B2B' }}>
                Contact Us
              </h2>
              <p className="text-base leading-relaxed mb-10" style={{ color: 'rgba(43,43,43,0.68)', fontFamily: 'Inter, sans-serif' }}>
                Have a question or not sure which offering is right for you? Reach out — we'd love to connect.
              </p>
              <div className="space-y-5">
                <a
                  href="mailto:jennie@resonanthealing444.com"
                  data-testid="contact-email"
                  className="flex items-center gap-5 group"
                  style={{ textDecoration: 'none' }}
                >
                  <div
                    className="flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 group-hover:scale-110"
                    style={{ width: '48px', height: '48px', background: 'rgba(198,169,107,0.15)', color: '#C6A96B' }}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '20px', height: '20px' }}>
                      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs tracking-[0.15em] uppercase font-medium mb-1" style={{ color: '#7E8C74', fontFamily: 'Inter, sans-serif' }}>Email</p>
                    <p className="text-base transition-colors duration-200 group-hover:text-[#C6A96B]" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                      jennie@resonanthealing444.com
                    </p>
                  </div>
                </a>
                <a
                  href="tel:8139567947"
                  data-testid="contact-phone"
                  className="flex items-center gap-5 group"
                  style={{ textDecoration: 'none' }}
                >
                  <div
                    className="flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 group-hover:scale-110"
                    style={{ width: '48px', height: '48px', background: 'rgba(198,169,107,0.15)', color: '#C6A96B' }}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '20px', height: '20px' }}>
                      <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.12 1.18 2 2 0 012.11 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs tracking-[0.15em] uppercase font-medium mb-1" style={{ color: '#7E8C74', fontFamily: 'Inter, sans-serif' }}>Phone</p>
                    <p className="text-base transition-colors duration-200 group-hover:text-[#C6A96B]" style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}>
                      813-956-7947
                    </p>
                  </div>
                </a>
              </div>
            </FadeIn>
            <FadeIn delay={200}>
              <div
                className="p-10 rounded-3xl text-center"
                style={{ background: '#F7F4EF', boxShadow: '0 16px 56px rgba(126,140,116,0.10)' }}
              >
                <div style={{ width: '1px', height: '40px', background: '#C6A96B', margin: '0 auto 24px' }} />
                <p className="font-serif text-xl sm:text-2xl mb-4" style={{ color: '#2B2B2B', fontStyle: 'italic' }}>
                  Not sure where to start?
                </p>
                <p className="text-sm leading-relaxed mb-8" style={{ color: 'rgba(43,43,43,0.65)', fontFamily: 'Inter, sans-serif' }}>
                  Book a free 30-minute discovery call and we'll find the right path forward together.
                </p>
                <a
                  href="https://calendly.com/jennie-resonanthealing444/30-minute-discovery-call"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-discovery-btn"
                  className="inline-block rounded-full text-sm font-medium transition-all duration-300 hover:opacity-85"
                  style={{ background: '#C6A96B', color: '#2B2B2B', padding: '14px 34px', fontFamily: 'Inter, sans-serif' }}
                >
                  Book a Discovery Call
                </a>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>

      {/* ── FINAL CTA ────────────────────────────────────────────────── */}
      <section id="final-cta" data-testid="final-cta-section" className="py-24 md:py-32 text-center" style={{ background: '#7E8C74' }}>
        <div className="max-w-2xl mx-auto px-6">
          <FadeIn>
            <p className="text-xs tracking-[0.35em] uppercase font-medium mb-8" style={{ color: 'rgba(247,244,239,0.65)', fontFamily: 'Inter, sans-serif' }}>
              The Next Step
            </p>
            <p className="font-serif text-2xl sm:text-3xl leading-relaxed mb-12" style={{ color: '#F7F4EF' }}>
              If you feel a resonance with this work, you're invited to take the next step.
            </p>
            <a
              href="https://forms.gle/acnQmapg39FqW7wL7"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-btn"
              className="inline-block rounded-full text-sm font-medium transition-all duration-300 hover:opacity-88 hover:shadow-2xl"
              style={{ background: '#C6A96B', color: '#2B2B2B', padding: '18px 52px', fontFamily: 'Inter, sans-serif' }}
            >
              Apply to Work Together
            </a>
          </FadeIn>
        </div>
      </section>

    </div>
  );
};

export default HomePage;
